const button = document.getElementsByClassName('white-outline-btn')[0]
let targetElement = document.getElementById('letsTalk');
let offsetTop

if (targetElement) {
    offsetTop = targetElement.offsetTop
    button.removeAttribute('href');
}

button.addEventListener('click', () => {

    if (!targetElement) {
        return
    }

    if (window.innerWidth <= 624) {
        window.scrollTo({top: offsetTop - 200, behavior: 'smooth'});
    } else if (window.innerWidth > 624 && window.innerWidth <= 768) {
        window.scrollTo({top: offsetTop - 270, behavior: 'smooth'});
    } else {
        targetElement.scrollIntoView({behavior: 'smooth'});
    }


})
